/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Filtre dropdown desktop : ouvre/ferme le panneau de filtres sur les pages collection ---
  var currentUrl = window.location.href;
  if (currentUrl.includes('/collections/') && !currentUrl.includes('/products/')) {
    setupFilterDropdown();
  }

  function setupFilterDropdown() {
    var filterButton = document.querySelector('[data-toggle-filters]');
    var filterContainer = document.querySelector('.collection__filters');

    if (!filterButton || !filterContainer) return;

    filterButton.addEventListener('click', function(event) {
      if (window.innerWidth < 768) return;
      event.stopPropagation();
      filterContainer.classList.toggle('visible');
    });

    document.addEventListener('click', function(event) {
      if (window.innerWidth < 768) return;
      if (!filterContainer.contains(event.target) && !filterButton.contains(event.target)) {
        filterContainer.classList.remove('visible');
      }
    });
  }





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
